import PrivateAppointmentEditor from '../PrivateAppointmentEditor/PrivateAppointmentEditor';
import PrivateAppointmentView from '../PrivateAppointmentEditor/PrivateAppointmentView';

import PrivateAppointmentFormBase from '../PrivateAppointmentEditor/Base/PrivateAppointmentFormBase';
enum PAclassNames {
    "private_appointment" = "private_appointment"
}

export {
    PrivateAppointmentEditor,
    PrivateAppointmentView,
    PrivateAppointmentFormBase,
    type PrivateAppointmentTypes,
    PAclassNames
}

namespace PrivateAppointmentTypes {
    export interface PrivateAppointment_Base extends more.EntityAPIResult {
        date_end: Date;
        date_start: Date;
        note: string;
        description: string;
    }
    export interface PrivateAppointment_Extended extends PrivateAppointment_Base {

    }
}